document.addEventListener("turbo:load", function () {
  const contentNavElm = document.querySelector("#content-navigation");

  if (contentNavElm) {
    const observeElm = document.querySelector(contentNavElm.dataset.target);

    document.body.dataset.scrollOffset = -72;
    const observer = new IntersectionObserver(
      ([e]) => {
        contentNavElm.classList.toggle(
          "show",
          !(e.boundingClientRect.bottom >= 0),
        );
      },
      { threshold: [0] },
    );
    observer.observe(observeElm);

    const contentCtaElm = document.querySelector("#content-navigation-cta");
    if (contentCtaElm) {
      const hideSections = ["#alle-termine"]
        .map((sel) => document.querySelector(sel))
        .filter(Boolean);
      const ctaHidden = new Set();

      const updateCtaVisibility = () => {
        contentCtaElm.classList.toggle("d-md-block", ctaHidden.size === 0);
      };

      if (hideSections.length > 0) {
        const ctaObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                ctaHidden.add(entry.target.id);
              } else {
                ctaHidden.delete(entry.target.id);
              }
            });
            updateCtaVisibility();
          },
          { threshold: [0] },
        );
        hideSections.forEach((el) => ctaObserver.observe(el));
      }
    }

    // Active state tracking for nav links — only one active at a time
    const navLinks = contentNavElm.querySelectorAll(".nav-link");
    const sectionIds = Array.from(navLinks).map((link) =>
      link.getAttribute("href").substring(1),
    );
    const sections = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (sections.length > 0) {
      const visibleSections = new Set();

      const setActiveLink = () => {
        // Find the topmost visible section (in DOM order)
        let activeId = null;
        for (const section of sections) {
          if (visibleSections.has(section.id)) {
            activeId = section.id;
            break;
          }
        }
        navLinks.forEach((link) => {
          link.classList.toggle(
            "active",
            link.getAttribute("href") === `#${activeId}`,
          );
        });
      };

      const sectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              visibleSections.add(entry.target.id);
            } else {
              visibleSections.delete(entry.target.id);
            }
          });
          setActiveLink();
        },
        { rootMargin: "-80px 0px -40% 0px", threshold: 0 },
      );

      sections.forEach((section) => sectionObserver.observe(section));
    }
  }
});
